import { motion } from "framer-motion";
import { BatteryCharging, ArrowUpRight } from "lucide-react";
import { SHOP_URL } from "@/constants/site";

export default function BatteryBanner() {
  return (
    <section className="relative overflow-hidden border-y border-[#39FF14]/20" data-testid="battery-banner">
      <img
        src="/images/battery-banner.jpg"
        alt="Акумулатори - продажба, монтаж и гаранция"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-black/80" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/70 to-transparent" />

      <div className="relative z-10 mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl"
        >
          <div className="mb-6 flex h-14 w-14 items-center justify-center bg-[#008A22] text-white">
            <BatteryCharging size={26} strokeWidth={2} />
          </div>
          <h2 className="font-display text-3xl font-extrabold uppercase leading-tight tracking-tight sm:text-5xl">
            Акумулатори — <span className="text-[#39FF14]">продажба, монтаж, гаранция</span>
          </h2>
          <p className="mt-6 text-base text-zinc-400 sm:text-lg">
            BANNER • BOSCH • VARTA • GIGAWAT • YUASA • FULBAT и други. Зарядни и стартови
            устройства CTEK, NOCO и BOSCH. Разгледайте пълния каталог в нашия онлайн магазин.
          </p>
          <a
            data-testid="battery-shop-link"
            href={SHOP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="green-glow group mt-10 inline-flex items-center gap-3 bg-[#39FF14] px-8 py-4 font-display text-sm font-bold uppercase tracking-widest text-black transition-colors duration-300 hover:bg-[#32E612]"
          >
            www.akumulator.pro
            <ArrowUpRight size={18} strokeWidth={2.5} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
